module.exports = __webpack_public_path__ + "static/media/thumb.16e7db3c.svg";